<div class="inner-content">
  <nz-breadcrumb>
    <nz-breadcrumb-item>首页</nz-breadcrumb-item>
    <nz-breadcrumb-item>诊断列表</nz-breadcrumb-item>
  </nz-breadcrumb>
  <div class="work-list">
    <div class="title flex-title" nz-flex style="width: 100%">
      <div class="title-left flex-item">工作台（已锁定）</div>
      <div class="title-right flex-item">
        <button nz-button nzType="default" (click)="settingTableHeader('workbench')">
          <i nz-icon nzType="setting"></i>
        </button>
      </div>
    </div>
    <nz-table #basicTable1 [nzData]="lockedCaseList" [nzTotal]="totalLockedCase" [nzBordered]="false" [nzSize]="'middle'" [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" [nzFrontPagination]="false" [nzShowPagination]="true" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" (nzPageIndexChange)="workPageIndexChange($event)" (nzPageSizeChange)="workPageSizeChange($event)">
      <thead>
        <tr>
          <ng-container *ngFor="let tableHeader of workTableHeader">
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'status' && tableHeader.isShow">状态</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'checkSerialNum' && tableHeader.isShow">病例号</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'patientName' && tableHeader.isShow">姓名</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'patientGender' && tableHeader.isShow">性别</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'patientAge' && tableHeader.isShow">年龄</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'deviceType' && tableHeader.isShow">设备类型</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'bodyPartExamined' && tableHeader.isShow">检查部位</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'uploadTime' && tableHeader.isShow">上传时间</th>
            <th nzWidth="{{ tableHeader.width }}px" [nzAlign]="'center'" *ngIf="tableHeader.prop === 'studyTime' && tableHeader.isShow">检查时间</th>
          </ng-container>
          <th nzWidth="120px" [nzAlign]="'center'">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of basicTable1.data">
          <ng-container *ngFor="let tableHeader of workTableHeader">
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'status' && tableHeader.isShow">
              <span [ngClass]="getStatusClass(status[item.status])">
                {{ status[item.status] }}
              </span>
            </td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'checkSerialNum' && tableHeader.isShow">{{ item.checkSerialNum }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'patientName' && tableHeader.isShow">{{ item.patientName }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'patientGender' && tableHeader.isShow">{{ formatGender(item.patientGender) }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'patientAge' && tableHeader.isShow">{{ item.patientAge }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'deviceType' && tableHeader.isShow">{{ item.deviceType }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'bodyPartExamined' && tableHeader.isShow">{{ item.bodyPartExamined }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'uploadTime' && tableHeader.isShow">{{ formatTime(item.uploadTime) }}</td>
            <td [nzAlign]="'center'" *ngIf="tableHeader.prop === 'studyTime' && tableHeader.isShow">{{ formatTime(item.studyTime) }}</td>
          </ng-container>
          <td [nzAlign]="'center'">
            <nz-button-group>
              <!-- <button nz-button nzType="default">补录</button> -->
              <button nz-button nzType="default" (click)="unlockReport(item.id)" [disabled]="!canUnlockBtn(item)">解锁</button>
              <button nz-button nzType="primary" (click)="lockReport(item.id)" [disabled]="!canDiagnosisBtn(item)">诊断</button>
              <!-- 召回报告 -->
              <button nz-button nzType="default" (click)="recallReport(item.id)" [disabled]="!canRecallBtn(item)">召回</button>
            </nz-button-group>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div class="search-box">
    <div nz-row [nzGutter]="0">
      <div nz-col nzFlex="280px">
        <div nz-row>
          <div nz-col class="label" nzFlex="80px">患者姓名</div>
          <div nz-col nzFlex="1">
            <input nz-input placeholder="请输入患者姓名" [(ngModel)]="searchParams.patientName" />
          </div>
        </div>
      </div>
      <div nz-col nzFlex="550px">
        <div nz-row>
          <div nz-col class="label" nzFlex="100px">上传时间</div>
          <div nz-col nzFlex="248px">
            <nz-range-picker [(ngModel)]="searchParams.date" style="border-radius: 8px 0 0 8px; border-right: none"></nz-range-picker>
          </div>
          <div nz-col class="quick-choose" nzFlex="180px">
            <nz-radio-group nzButtonStyle="solid" [(ngModel)]="quickDateType" (ngModelChange)="quickDateChange($event)">
              <label nz-radio-button nzValue="today">当日</label>
              <label nz-radio-button nzValue="month">本月</label>
              <label nz-radio-button nzValue="year">全年</label>
            </nz-radio-group>
          </div>
        </div>
      </div>
      <div nz-col nzFlex="280px">
        <div nz-row>
          <div nz-col class="label" nzFlex="100px">设备类型</div>
          <div nz-col nzFlex="auto">
            <!-- deviceList select -->
            <nz-select [(ngModel)]="searchParams.deviceTypes" nzShowSearch nzPlaceHolder="请选择设备类型" nzMode="multiple" style="width: 100%">
              <nz-option *ngFor="let item of deviceList" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <div nz-col nzFlex="140px" style="text-align: right">
        <button nz-button nzType="primary" (click)="search()">搜索</button>
        <button nz-button nzType="default" (click)="reset()">重置</button>
      </div>
      <div nz-col nzFlex="1"></div>
    </div>
  </div>
  <div class="table-container">
    <div class="search-group">
      <div class="item-list">
        <div class="item" [ngClass]="selectedGroup.id === '' ? 'active' : ''" (click)="selectedGroup = { id: '' }; search()">全部</div>
        <div class="item" [ngClass]="selectedGroup.id === item.id ? 'active' : ''" *ngFor="let item of searchGroups">
          <span (click)="selectedGroup = item; search()">{{ item.name }}</span>
          <!-- 编辑 -->
          <i nz-icon nzType="edit" (click)="editGroup(item)" style="font-size: 12px; margin-left: 5px"></i>
        </div>
        <!-- 新增 -->
        <div class="item" (click)="addGroup()">
          <i nz-icon nzType="plus"></i>
        </div>
      </div>
    </div>
    <nz-table #basicTable2 [nzData]="dataList" [nzTotal]="total" [nzBordered]="false" [nzSize]="'middle'" [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" [nzFrontPagination]="false" [nzShowPagination]="true" [nzPageSize]="searchParams.pageSize" [nzPageIndex]="searchParams.pageIndex" (nzPageIndexChange)="pageIndexChange($event)" (nzPageSizeChange)="pageSizeChange($event)">
      <thead>
        <tr>
          <th nzWidth="100px" [nzAlign]="'center'">状态</th>
          <th nzWidth="150px" [nzAlign]="'center'">病例号</th>
          <th nzWidth="150px" [nzAlign]="'center'">姓名</th>
          <th nzWidth="100px" [nzAlign]="'center'">性别</th>
          <th nzWidth="100px" [nzAlign]="'center'">年龄</th>
          <th nzMinWidth="150px" [nzAlign]="'center'">设备类型</th>
          <th nzMinWidth="150px" [nzAlign]="'center'">检查部位</th>
          <th [nzAlign]="'center'">上传时间</th>
          <th [nzAlign]="'center'">检查时间</th>
          <th nzWidth="120px" [nzAlign]="'center'">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of basicTable2.data">
          <td [nzAlign]="'center'">
            <!-- 锁定图标 -->
            <ng-container *ngIf="item.lockStatus != 'NONE'">
              <i nz-icon [nzType]="item.lockStatus != 'NONE' ? 'lock' : 'unlock'" style="color: #b54f41" [nzTheme]="item.lockStatus != 'NONE' ? 'fill' : 'outline'"></i>
            </ng-container>
            <span [ngClass]="getStatusClass(status[item.status])">
              {{ status[item.status] }}
            </span>
          </td>
          <td [nzAlign]="'center'">{{ item.checkSerialNum }}</td>
          <td [nzAlign]="'center'">{{ item.patientName }}</td>
          <td [nzAlign]="'center'">{{ formatGender(item.patientGender) }}</td>
          <td [nzAlign]="'center'">{{ item.patientAge }}</td>
          <td [nzAlign]="'center'">{{ item.deviceType }}</td>
          <td [nzAlign]="'center'">{{ item.bodyPartExamined }}</td>
          <td [nzAlign]="'center'">{{ formatTime(item.uploadTime) }}</td>
          <td [nzAlign]="'center'">{{ formatTime(item.studyTime) }}</td>
          <td [nzAlign]="'center'">
            <nz-button-group>
              <!-- <button nz-button nzType="default">补录</button> -->
              <button nz-button nzType="primary" (click)="lockReport(item.id)" *ngIf="role.roleCode == 'reporter'" [disabled]="!canCasePoolDiagnosisBtn(item)">诊断</button>
              <!-- 审核 -->
              <button nz-button nzType="primary" (click)="auditReport(item.id)" *ngIf="role.roleCode == 'auditor'" [disabled]="!canCasePoolAuditBtn(item)">审核</button>
              <!-- 召回 -->
              <button nz-button nzType="default" (click)="recallReport(item.id)" *ngIf="canRecallBtn(item)">召回</button>
            </nz-button-group>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-template #drawerFooter>
  <div class="footer-buttons">
    <button nz-button nzType="primary" (click)="onSubmit()">保存</button>
    <button nz-button nzType="default" (click)="onCancel()">取消</button>
  </div>
</ng-template>
<ng-template #searchGroupDrawerFooter>
  <div class="footer-buttons">
    <button nz-button nzType="default" (click)="deleteGroup()">删除</button>
    <button nz-button nzType="primary" (click)="onSubmitSearchGroup()">保存</button>
    <button nz-button nzType="default" (click)="onCancelSearchGroup()">取消</button>
  </div>
</ng-template>
